import { faTimesCircle, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { IConfirmModal, ICancelContinueModal } from "interfaces/IModal";
import { useState } from "react";

/**
 * Custom props for the useModalHandler hook
 */
interface Props {
    /**
     * initial modal message
     */
    initialMessage?: string;
    /**
     * 
     */
}

/**
 * Custom hook to use the modal handler component
 * @returns some default states and set functions for the modal state
 */
export const useModalHandler = ({ initialMessage }: Props) => {
    const errorModal: IConfirmModal = {
        title: "Confirmación",
        message: "Error al conectar con el servidor. Inténtalo más tarde.",
        icon: faTimesCircle,
        iconColor: "text-danger",
        onHide() { },
        show: true
    }
    const initialModal = {
        show: false,
        onHide: () => { },
        onConfirm: () => { },
        title: "Atención",
        message: initialMessage ?? "",
        icon: faExclamationTriangle,
        iconColor: "text-danger"
    };
    const [modal, setModal] = useState<IConfirmModal | ICancelContinueModal>(initialModal);

    /**
     * function that reset the modal to its initial value
     */
    const closeModal = () => setModal(initialModal);

    return ({
        initialModal,
        errorModal,
        modal,
        setModal,
        closeModal
    });
};
